import { useState } from "react";
import { useLocation } from "react-router-dom";

import ImageOnGrid from "../components/ImageOnGrid";
import Modal from "../ui/Modal";

import classes from "./css/ShowDetail.module.css";

const ShowDetailPage = () => {
  const [isClicked, setIsClicked] = useState(false);
  const [selectedImage, setSelectedImage] = useState();

  const location = useLocation();

  let onClickHandler = (img) => {
    if (window.innerWidth < 760) {
      return;
    }

    setIsClicked(true);
    setSelectedImage(img);
    document.body.style.overflow = "hidden";
  };

  const onCloseHandler = () => {
    setIsClicked(false);
    document.body.style.overflow = "unset";
  };

  const wrapTextHandler = () => {
    if (
      location.state.title === "Medeia, Medeias, Medeia" ||
      location.state.title === "Medea"
    )
      return (
        <p>
          Studio sul mito di Medea <br /> (Roma 2010: Esedra di Marco Aurelio,
          Musei Capitolini - Roma 2013 Teatro Due - Teatro Antico di Segesta
          2015)
        </p>
      );
    else if (location.state.title === "Sogno di una notte di mezza estate")
      return (
        <p>
          “Se le nostre ombre offeso v’hanno
          <br />
          Immaginate e sarà poco il danno,
          <br />
          che quanto vi comparve qui davanti,
          <br />
          fu sogno, fu inganno, fulmine di pochi istanti… “
        </p>
      );
  };

  return (
    <>
      {isClicked && <Modal onClose={onCloseHandler} image={selectedImage} />}
      <div className={classes.main_detail}>
        <div className={classes.info_detail}>
          <h1>{location.state.title}</h1>
          <h5>{location.state.author}</h5>
          <h4>{location.state.date}</h4>
        </div>

        <img src={location.state.image_main} alt="show detail" />

        <div className={classes.description}>
          <p>{location.state.description}</p>
          {wrapTextHandler()}
        </div>

        <div className={classes.grid_detail}>
          <ImageOnGrid
            onClick={() => onClickHandler(location.state.image_one)}
            image={location.state.image_one}
          />
          <ImageOnGrid
            onClick={() => onClickHandler(location.state.image_two)}
            image={location.state.image_two}
          />
          <ImageOnGrid
            onClick={() => onClickHandler(location.state.image_three)}
            image={location.state.image_three}
          />
          <ImageOnGrid
            onClick={() => onClickHandler(location.state.image_four)}
            image={location.state.image_four}
          />
          <ImageOnGrid
            onClick={() => onClickHandler(location.state.image_five)}
            image={location.state.image_five}
          />
          <ImageOnGrid
            onClick={() => onClickHandler(location.state.image_six)}
            image={location.state.image_six}
          />
        </div>
      </div>
    </>
  );
};

export default ShowDetailPage;
